import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, ViewChild, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL, UserRoles, DataListModel } from '../../shared/config';
import { CostAndExpenseService } from '../models/cost-expense.service';
import { PersonModel } from '../../person/models/person.model';
import { PersonService } from '../../person/models/person.service';

@Component({
  selector: 'wego-costandexpense-person-popup',
  template: require('../views/costandexpense-person-popup.component.html'),
  providers: [CostAndExpenseService,PersonService]
})

export class CostAndExpensePersonPopupComponent implements OnInit, OnChanges {
  SelectedNames: string[] = [];
  SelectedList: string[] = [];
  DataListModel: DataListModel;
  personList: PersonModel[];
  message: string;
  apiErrorMsg: string;
  isLoading: boolean;
  LblIcon: string = "fa fa-plus-square";
  isParentCheck: boolean = false;
  pageName:string="COST_EXPENSE_LIST";
  
  @Output('OnSuccessSelect') onSuccessSelect = new EventEmitter();
  @ViewChild('personModal') public personModal: any;

  constructor(private costAndExpenseService: CostAndExpenseService
    , private personService:PersonService
    , private authService: AuthService
    , private router: Router
    , private translate: TranslateService) { }

  ngOnInit() {
    this.DataListModel = new DataListModel();
    this.DataListModel.searchField = ["userName", "firstName", "lastName"];
  }

  ngOnChanges(change: any) {
    console.log(change);
  }

  public show(SelectedList: string[], SelectedNamesList: string[]): void {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.sortType = "";
    this.DataListModel.sortReverse = null;
    this.DataListModel.searchTerm = "";
    this.DataListModel.infoMessage = "";
    this.SelectedList = SelectedList;
    this.SelectedNames = SelectedNamesList;
    this.GetPersonList();
    this.personModal.show();
  }

  public hide(): void {
    this.personModal.hide();
  }

  private GetPersonList() {
    this.isLoading = true;
    this.personService.GetPersonListByAccessRight(this.DataListModel,this.pageName)
      .subscribe(
      res => {
        this.personList = res.data;
        this.personList.forEach(x => x.isChecked =
          (this.SelectedList.indexOf(x.personMasterHashId) > -1)
        );        
        this.isParentCheck = this.personList.every(x => x.isChecked);
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  private select(person: PersonModel): void {
    this.isLoading = true;
    this.onSuccessSelect.emit({ PersonHashID: person.personMasterHashId, PersonName: person.userName });
    this.isLoading = false;
    this.hide();
  }

  private selectMultiple(): void {
    this.isLoading = true;

    this.onSuccessSelect.emit({ PersonHashID: this.SelectedList, PersonName: this.SelectedNames });
    this.isLoading = false;
    this.hide();
  }

  private ItemCheckChanged(PersonMasterHashID: string, PersonName: string, isChecked: any) {
    if (isChecked) {
      if (this.SelectedList.indexOf(PersonMasterHashID) == -1) {
        this.SelectedList.push(PersonMasterHashID);
      }
      if (this.SelectedNames.indexOf(PersonName) == -1) {
        this.SelectedNames.push(PersonName);
      }
      this.isParentCheck = this.personList.filter(x => x.personMasterHashId != PersonMasterHashID).every(x => x.isChecked);
    } else {
      this.SelectedList = this.SelectedList.filter(x => x != PersonMasterHashID);
      this.SelectedNames = this.SelectedNames.filter(x => x != PersonName);
      this.isParentCheck = false;
    }
  }

  public OnParentCheck(isChecked: boolean) {
    this.personList.forEach(x => {
      x.isChecked = isChecked;
      if (isChecked) {
        if (this.SelectedList.indexOf(x.personMasterHashId) == -1) {
          this.SelectedList.push(x.personMasterHashId);
        }
        if (this.SelectedNames.indexOf(x.userName) == -1) {
          this.SelectedNames.push(x.userName);
        }
      } else {
        this.SelectedList = this.SelectedList.filter(y => y != x.personMasterHashId);
        this.SelectedNames = this.SelectedNames.filter(y => y != x.userName);
      }
    });
  }

  private OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetPersonList();
  }

  private OnSearch(event: any) {
    this.DataListModel.searchTerm = event.searchTerm;
    this.DataListModel.currentPage = 1;
    this.GetPersonList();
  }

  private OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetPersonList();
  };

  public OnPagingChange(event: any) {
    console.log(this.DataListModel);
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetPersonList();
  }
  private OnSuccessSelect() {
  }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/cost-expenses/components/costandexpense-person-popup.component.ts